import {useMemo} from 'react'
import {useGameStore} from '../GameStoreContext'
import {MechanicValidatorRoad} from '@colonist/game-mechanic-validators'
import {usePlayerValidators} from './usePlayerValidators'
import {useCurrentStateValidator} from './useCurrentStateValidator'
import {useMapValidator} from './useMapValidator'

export const useMechanicValidatorRoad = () => {
    const {playerValidators} = usePlayerValidators()
    const mapValidator = useMapValidator()
    const currentStateValidator = useCurrentStateValidator()
    const mechanicRoadState = useGameStore((state) => state.gameState.mechanicRoadState)

    return useMemo(() => {
        if(!mechanicRoadState) return undefined
        return new MechanicValidatorRoad(playerValidators, mapValidator, currentStateValidator, mechanicRoadState)
    }, [playerValidators, mapValidator, currentStateValidator, mechanicRoadState])
}
